// this is where we map through all the questions
// and populate the Survey component
import React from 'react';
import { DatePicker, Rate, Select } from 'antd';
import { Dropdown } from '../../common/Inputs';
// // please leave this inside for antd to style right
// import 'antd/dist/antd.css';
import moment from 'moment';
import { capitalize } from '../../../helpers';

import {
  RadioField,
  TextField,
  QuestionWrapper,
  SectionCategory,
  SubGroup,
  Warning,
  RateDiv,
  QuestionGroup,
  QuestionText,
  GroupQuestionText,
  ListWrapper,
  InnerQuestionText
} from './Questions.style';

import {
  getDepartmentDivisions,
  isDepartmentVisible
} from './departmentVisibility';

const { Option } = Select;

// renders questions accordingly to their input type
const renderQuestionInputType = (
  inputType,
  questionsList,
  errorArray,
  questionId,
  answers,
  index,
  questionText,
  helperText,
  onChange,
  options,
  handleOther,
  _subGroup,
  errors,
  handleAntdDatePicker,
  group,
  participantField,
  handleStarChange,
  nextQuestionID,
  setCurrentQuestion,
  handleDropdown,
  code,
  setMaxNumber,
  answeredQuestionsIds,
  followUpQuestion,
  multiple,
  rateLabels,
  isRequired,
  org
) => {
  const subGroup = '';
  questionText = capitalize(questionText);
  helperText = Array.isArray(helperText)
    ? helperText.map((line, i) => (i === 0 ? capitalize(line) : line))
    : capitalize(helperText);
  if (inputType === 'text') {
    return (
      <TextField>
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>
          <p className="helpertext">{helperText}</p>
        </header>

        <div>
          <input
            id={index}
            name={questionId}
            type="text"
            onChange={onChange}
            data-group={group.text}
            data-field={participantField}
            value={
              answers[questionId]?.answer ? answers[questionId].answer : ''
            }
            onBlur={() => setCurrentQuestion(nextQuestionID)}
            onKeyDown={event => {
              if (event.keyCode === 13) {
                event.preventDefault();
                return setCurrentQuestion(nextQuestionID);
              }
              return null;
            }}
          />
        </div>
        <Warning>
          {!answeredQuestionsIds?.includes(questionId) &&
            isRequired &&
            '* This question must be answered'}
        </Warning>
      </TextField>
    );
  }
  if (inputType === 'date') {
    return (
      <TextField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>
          <p className="helpertext">{helperText}</p>
        </header>
        <DatePicker
          id={index}
          name={questionId}
          onChange={value =>
            handleAntdDatePicker(
              questionId,
              value,
              group.text,
              participantField
            )
          }
          value={answers[questionId]?.answer}
          onBlur={() => setCurrentQuestion(nextQuestionID)}
          defaultValue={moment()}
        />
        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </TextField>
    );
  }
  if (inputType === 'fromZeroToTen') {
    return (
      <TextField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>
          <p className="helpertext">Please specify number</p>

          <p className="helpertext">{helperText}</p>
        </header>
        <input
          id={index}
          name={questionId}
          type="number"
          min="0"
          max="10"
          onChange={onChange}
          data-group={group.text}
          data-field={participantField}
          data-code={code}
          data-type={inputType}
          value={answers[questionId]?.answer ? answers[questionId].answer : ''}
          onBlur={e => {
            setCurrentQuestion(nextQuestionID);
            return setMaxNumber(code, e.target.value);
          }}
          onKeyDown={event => {
            if (event.keyCode === 13) {
              event.preventDefault();
              return setCurrentQuestion(nextQuestionID);
            }
            return null;
          }}
        />
        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </TextField>
    );
  }
  if (inputType === 'rateFrom0To5') {
    return (
      <TextField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>

          <p className="helpertext">{helperText}</p>
        </header>
        <ListWrapper single>
          <RateDiv>
            <Rate
              id={`sliderInput-${index}`}
              name={questionId}
              allowClear={false}
              count={5}
              onChange={value => {
                handleStarChange(value, questionId, participantField);
                return setCurrentQuestion(nextQuestionID);
              }}
              unanswered={
                errorArray.includes(questionId) && !answers[questionId]
              }
              data-group={group.text}
              data-field={participantField}
              onBlur={() => setCurrentQuestion(nextQuestionID)}
              value={answers[questionId]?.answer}
              tooltips={rateLabels}
            />
          </RateDiv>
        </ListWrapper>

        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </TextField>
    );
  }
  if (inputType === 'matrixRateFrom0To5') {
    return (
      <TextField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>

          <p className="helpertext">{helperText}</p>
        </header>
        {questionsList &&
          questionsList.map((question, i) => {
            return (
              <ListWrapper key={index + question} first={i === 0}>
                <InnerQuestionText id={index + question}>
                  {question}
                </InnerQuestionText>
                <RateDiv>
                  <Rate
                    id={`sliderInput-${index}`}
                    name={question + i}
                    allowClear={false}
                    count={5}
                    onChange={value => {
                      const answerObj = answers[questionId]?.answer || {};
                      answerObj[question] = value;

                      handleStarChange(answerObj, questionId, participantField);
                      const subAnswers =
                        answers[questionId]?.answer &&
                        Object.values(answers[questionId]?.answer);

                      if (subAnswers?.length === questionsList?.length) {
                        return setCurrentQuestion(nextQuestionID);
                      }
                    }}
                    unanswered={
                      errorArray.includes(questionId) && !answers[questionId]
                    }
                    data-group={group.text}
                    data-field={participantField}
                    value={
                      answers[questionId]?.answer &&
                      answers[questionId]?.answer[question]
                    }
                    tooltips={rateLabels}
                  />
                </RateDiv>
              </ListWrapper>
            );
          })}

        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </TextField>
    );
  }

  if (inputType === 'radio') {
    return (
      <RadioField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>
          <p className="helpertext">{helperText}</p>
        </header>
        <div className="answers">
          {options.map(e => {
            const value = e;
            const uniqueId = e + questionId;
            return (
              <div key={`${value}parent`}>
                <div key={`${value}child`}>
                  <label htmlFor={uniqueId}>
                    <input
                      value={value}
                      checked={
                        answers[questionId]?.answer === value ? value : ''
                      }
                      id={uniqueId}
                      name={questionId}
                      type="radio"
                      onChange={radioE => {
                        onChange(radioE);
                        if (
                          !followUpQuestion?.ifAnswerIsOneOf.includes(
                            radioE.target.value
                          ) &&
                          !radioE.target.value
                            .toLowerCase()
                            .includes('please specify')
                        ) {
                          return setCurrentQuestion(nextQuestionID);
                        }
                      }}
                      data-group={group.text}
                      data-field={participantField}
                    />
                    <span className="checkmark" />
                    <p>{value}</p>
                  </label>
                </div>
              </div>
            );
          })}
        </div>
        <div className="other-div">
          {/* Load "Other" div */}

          {answers[questionId]?.answer
            ?.toLowerCase()
            ?.includes('please specify') ||
          followUpQuestion?.ifAnswerIsOneOf.includes(
            answers[questionId]?.answer
          ) ? (
            <TextField
              unanswered={
                errorArray.includes(questionId) && !answers[questionId]
              }
            >
              <p>{followUpQuestion?.text || 'Please specify:'}</p>
              <input
                id="other"
                name={questionId}
                type="text"
                onChange={handleOther}
                data-group={group.text}
                data-field={participantField}
                onBlur={() => setCurrentQuestion(nextQuestionID)}
                autoFocus
              />
            </TextField>
          ) : (
            ''
          )}
        </div>
        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </RadioField>
    );
  }
  if (inputType === 'dropdown') {
    return (
      <RadioField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>
          <p className="helpertext">{helperText}</p>
        </header>

        <Select
          value={answers[questionId]?.answer}
          defaultActiveFirstOption={false}
          onChange={value => {
            handleDropdown(value, questionId, participantField);
            return setCurrentQuestion(nextQuestionID);
          }}
          notFoundContent={null}
          onBlur={() => setCurrentQuestion(nextQuestionID)}
          mode={multiple ? 'multiple' : 'default'}
        >
          {participantField === 'department'
            ? getDepartmentDivisions(org, options).map(option => (
                <Option key={option}>{option}</Option>
              ))
            : options.map(option => <Option key={option}>{option}</Option>)}
        </Select>

        {!multiple ? (
          <div className="other-div">
            {/* Load "Other" div */}
            {answers[questionId]?.answer
              ?.toLowerCase()
              ?.includes('please specify') ? (
              <TextField
                unanswered={
                  errorArray.includes(questionId) && !answers[questionId]
                }
              >
                <p>Please specify:</p>
                <input
                  id="other"
                  name={questionId}
                  type="text"
                  onChange={handleOther}
                  data-group={group.text}
                  data-field={participantField}
                  onBlur={() => setCurrentQuestion(nextQuestionID)}
                  autoFocus
                />
              </TextField>
            ) : (
              ''
            )}
          </div>
        ) : (
          <div className="other-div">
            {/* Load "Other" div */}
            {answers[questionId]?.answer?.includes('Other, please specify') ? (
              <TextField
                unanswered={
                  errorArray.includes(questionId) && !answers[questionId]
                }
              >
                <p>Please specify:</p>
                <input
                  id="other"
                  name={questionId}
                  type="text"
                  onChange={handleOther}
                  data-group={group.text}
                  data-field={participantField}
                  onBlur={() => setCurrentQuestion(nextQuestionID)}
                  autoFocus
                />
              </TextField>
            ) : (
              ''
            )}
          </div>
        )}
        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </RadioField>
    );
  }
  if (inputType === 'groupedDropDown') {
    return (
      <RadioField
        unanswered={errorArray.includes(questionId) && !answers[questionId]}
      >
        <header>
          {subGroup && <SubGroup>{subGroup}</SubGroup>}
          <QuestionText id={index}>{questionText}</QuestionText>
          <p className="helpertext">{helperText}</p>
        </header>
        <Dropdown
          selected={answers[questionId]?.answer}
          groupedOptions
          options={options}
          handleChange={(value, option, b) => {
            handleDropdown(
              option?.key?.replace('_', ' - '),
              questionId,
              participantField
            );
            return setCurrentQuestion(nextQuestionID);
          }}
        />

        <div className="other-div">
          {/* Load "Other" div */}
          {answers[questionId]?.answer
            ?.toLowerCase()
            ?.includes('please specify') ? (
            <TextField
              unanswered={
                errorArray.includes(questionId) && !answers[questionId]
              }
            >
              <p>Please specify:</p>
              <input
                id="other"
                name={questionId}
                type="text"
                onChange={handleOther}
                data-group={group.text}
                data-field={participantField}
                onBlur={() => setCurrentQuestion(nextQuestionID)}
                autoFocus
              />
            </TextField>
          ) : (
            ''
          )}
        </div>
        {!answeredQuestionsIds?.includes(questionId) && (
          <Warning>* This question must be answered</Warning>
        )}
      </RadioField>
    );
  }
  return null;
};

// uses renderQuestionInputType fnc from above and loops over questions array
const questionsRender = (
  arrayOfQuestions,
  answers,
  errorArray,
  onChange,
  handleOther,
  errors,
  handleAntdDatePicker,
  handleStarChange,
  setCurrentQuestion,
  handleDropdown,
  setMaxNumber,
  answeredQuestionsIds
) => {
  const organisationValue = answers
    ? Object.values(answers)?.filter(e => {
        if ('organisation' === e.participantField) return e.answer;
      })
    : null;
  const org = organisationValue?.length ? organisationValue[0].answer : null;
  const followUpQs = arrayOfQuestions.filter(
    question => question.group.text === 'follow up'
  );
  const demographicQs = arrayOfQuestions.filter(
    question => question.group.text === 'demographic'
  );

  const behaviourQs = arrayOfQuestions.filter(
    question => question.group.text === 'Behavioural Insights'
  );

  const trainerQs = arrayOfQuestions.filter(
    question => question.group.text === 'about your trainer'
  );
  const TtTFeedback = arrayOfQuestions.filter(
    question => question.group.text === 'Train the Trainer feedback'
  );

  return [followUpQs, demographicQs, behaviourQs, TtTFeedback, trainerQs]
    .filter(section => section.length > 0)
    .map((section, index) => (
      // map through each section
      <QuestionGroup key={section[0].group}>
        <SectionCategory>{section[0] && section[0].group.text}</SectionCategory>
        {section &&
          section.map((el, qIndex) => {
            // map through all the questions
            // el is one question
            const {
              _id: questionId,
              text: questionText,
              helperText,
              options,
              group,
              participantField,
              code,
              questionsList,
              followUpQuestion,
              multiple,
              rateLabels,
              isRequired = true
            } = el;

            const inputType = el.questionType.desc;
            const nextQuestion = section[qIndex + 1];
            const nextQuestionID = nextQuestion ? nextQuestion._id : 'end';
            const prevQuestion = section[qIndex - 1];
            const prevQuestionID = prevQuestion && prevQuestion._id;
            const { subGroupQuestion, order } = el.subGroup || {};
            const isDisabled = () => {
              if (moment.isMoment(answers[prevQuestionID]?.answer)) {
                return false;
              }
              if (prevQuestion?.isRequired === false) {
                return false;
              }

              if (
                answers[prevQuestionID]?.answer &&
                !Array.isArray(answers[prevQuestionID]?.answer) &&
                typeof answers[prevQuestionID]?.answer === 'object'
              ) {
                if (
                  Object.keys(answers[prevQuestionID]?.answer).length ===
                  prevQuestion.questionsList.length
                ) {
                  return false;
                }
                return true;
              }
              return false;
            };
            return (
              <>
                {order === 1 && subGroupQuestion && (
                  <GroupQuestionText>{subGroupQuestion}</GroupQuestionText>
                )}
                {participantField === 'department' ? (
                  isDepartmentVisible(org, options) ? (
                    <QuestionWrapper
                      key={questionId}
                      name={questionId}
                      disabled={
                        isDisabled() ||
                        (!answers[prevQuestionID]?.answer &&
                          qIndex !== 0 &&
                          prevQuestion?.isRequired !== false)
                      }
                      id={questionId}
                    >
                      {renderQuestionInputType(
                        inputType,
                        questionsList,
                        errorArray,
                        questionId,
                        answers,
                        index,
                        subGroupQuestion
                          ? questionText.replace(`${subGroupQuestion} - `, '')
                          : questionText,
                        helperText,
                        onChange,
                        options,
                        handleOther,
                        el.subGroup,
                        errors,
                        handleAntdDatePicker,
                        group,
                        participantField,
                        handleStarChange,
                        nextQuestionID,
                        setCurrentQuestion,
                        handleDropdown,
                        code,
                        setMaxNumber,
                        answeredQuestionsIds,
                        followUpQuestion,
                        multiple,
                        rateLabels,
                        isRequired,
                        org
                      )}
                    </QuestionWrapper>
                  ) : null
                ) : (
                  <QuestionWrapper
                    key={questionId}
                    name={questionId}
                    disabled={
                      isDisabled() ||
                      (!answers[prevQuestionID]?.answer &&
                        qIndex !== 0 &&
                        prevQuestion?.isRequired !== false)
                    }
                    id={questionId}
                  >
                    {renderQuestionInputType(
                      inputType,
                      questionsList,
                      errorArray,
                      questionId,
                      answers,
                      index,
                      subGroupQuestion
                        ? questionText.replace(`${subGroupQuestion} - `, '')
                        : questionText,
                      helperText,
                      onChange,
                      options,
                      handleOther,
                      el.subGroup,
                      errors,
                      handleAntdDatePicker,
                      group,
                      participantField,
                      handleStarChange,
                      nextQuestionID,
                      setCurrentQuestion,
                      handleDropdown,
                      code,
                      setMaxNumber,
                      answeredQuestionsIds,
                      followUpQuestion,
                      multiple,
                      rateLabels,
                      isRequired,
                      org
                    )}
                  </QuestionWrapper>
                )}
              </>
            );
          })}
      </QuestionGroup>
    ));
};

export default class Questions extends React.Component {
  state = {
    currentQuestion: null
  };

  componentDidUpdate() {
    const { currentQuestion } = this.state;
    const element = document.getElementById(currentQuestion);
    if (element && currentQuestion !== 'end') {
      const isSmoothScrollSupported =
        'scrollBehavior' in document.documentElement.style;

      if (isSmoothScrollSupported) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    } else if (currentQuestion === 'end') {
      setTimeout(() => {
        // scroll.scrollToBottom();
        this.setState({ currentQuestion: null });
      }, 100);
    }
  }

  // set the current question to focus on
  setCurrentQuestion = questionId => {
    this.setState({ currentQuestion: questionId });
  };

  render() {
    const {
      onChange,
      questions,
      handleOther,
      renderSkipButtons,
      answers,
      answeredQuestionsIds,
      errors,
      handleAntdDatePicker,
      handleStarChange,
      handleDropdown,
      setMaxNumber
    } = this.props;
    const { setCurrentQuestion } = this;

    const errorArray = Object.keys(errors);

    return (
      <React.Fragment>
        <QuestionGroup>
          {questionsRender(
            questions,
            answers,
            errorArray,
            onChange,
            handleOther,
            errors,
            handleAntdDatePicker,
            handleStarChange,
            setCurrentQuestion,
            handleDropdown,
            setMaxNumber,
            answeredQuestionsIds
          )}
          {renderSkipButtons}
        </QuestionGroup>
      </React.Fragment>
    );
  }
}
